// @flow
// @jsx h

declare var STRIPE_API_KEY: string;

// External librairies
import { h, Component } from "preact";
import { Text, withText } from "preact-i18n";

import  Loading  from "elc-loading";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

// Components
//import StripePaymentForm from "./stripe-payment-form";
import PaymentForm from './payment-form/PaymentForm';

// API
import { StripeService } from "elc-internal-api";

// Styles
import styles from "./style.scss";

const stripePromise = loadStripe(STRIPE_API_KEY);

const appearance = {
  //theme: 'flat', // Utilisation du thème "flat"
  variables: {

    colorBackground: '#f7f7f7',
    colorTextPlaceholder : '#aeb3b9', //styles.placeholderColor
    colorText: '#808c9c', //styles.textColor
    colorDanger: '#ff0000',

    borderRadius: '0',

    fontWeightBold: '600',
    fontSizeBase: '15px',
    lineHeight: '18px',
  },
  rules: {
    '.Label': {
      color: '#aeb3b9',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight:'1.125rem'
    },
    '.Input': {
      borderColor: '#aeb3b9',
      color: '#808c9c',
      fontWeight: 'bold',
    },
    '.Field' : {
      marginBottom: '4px',
    }
  },
};

class StripePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientSecret : null,
      pi : null,
      options: {
        clientSecret: null,
        locale : props.locale,
        paymentMethodCreation: 'manual',
        appearance
      },
      errorPaiement: null
    }
  }

  componentDidMount() {
    // console.log("this.props.order",  this.props.order);
    // console.log("this.props.paymentMethod",  this.props.paymentMethod);
    // console.log("this.props.callbackStripe",  this.props.callbackStripe);
    // console.log("this.props.locale",  this.props.locale);
  // Crée un PaymentIntent lors du chargement du composant
  StripeService.createPaymentIntent(
    {
      order: this.props.order,
      paymentMethod : this.props.paymentMethod,
      locale: this.props.locale,
      callbackStripe : this.props.callbackStripe
    },
    (res) => {
      //console.log("createPaymentIntent - res", res)
      if (res.stringCode) {
        console.error(res);
        this.props.setPiError(res.detail)
        return;
      } else {
      // console.log('createPaymentIntent res:', res);
      // console.log('props.locale:', this.props.locale);
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          clientSecret: res.client_secret
        }
      }));
      this.setState({clientSecret: res.client_secret});
      }
      this.setState({pi: res.pi});
      if (this.props.pageDidMountOrUpdate) {
        this.props.pageDidMountOrUpdate();
      }
    }
  );
  };

    componentDidUpdate() {
    if (this.props.pageDidMountOrUpdate) {
      this.props.pageDidMountOrUpdate();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.locale !== this.props.locale) {
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          locale: nextProps.locale
        }
      }));
    }
  }

  render({
    hash,
    config,
    currency,
    locale,
    order,
    paymentMethod,
    setPaymentMethod,
    removeBeforeUnloadListener,
    callbackStripe,
    urlToShop,
    checkSession,
    sessionValid,
    dataAssurance,
    initAssuranceMeetch,
    pageDidMountOrUpdate
  },{
    clientSecret,
    pi,
    options
    }) {
    // console.log('this props', this.props)
    // console.log('arguments', arguments)
    // console.log('Current option state:', this.state.options)
    return (
      <div>
      {clientSecret &&
        <Elements stripe={stripePromise} options={options} >
          <PaymentForm
          order={order}
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          locale={locale}
          currency={currency}
          callbackStripe={callbackStripe}
          pi={pi}
          checkSession={checkSession}
          sessionValid={sessionValid}
          dataAssurance={dataAssurance}
          initAssuranceMeetch={initAssuranceMeetch}
          pageDidMountOrUpdate={pageDidMountOrUpdate}
           />
        </Elements>
      }
      {!clientSecret &&
        <Loading />}
      </div>
    );
  }
}

export default StripePayment;
